import { AddEdit } from '../../../../../interfaces/stockist.interface';
import { Validation } from '../../../../../interfaces/common';
import {
  VALIDATION_FIELD_MAPPING,
  APP_ERROR_MESSAGES,
  Regex,
} from '../../../../../utils/appConstant';

export const validateAddEditForm = (formData: AddEdit, fieldToValidate?: string) => {
  const validations: Validation = { validate: true, fields: [] };

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.name) {
    if (!formData.name.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.name,
        message: APP_ERROR_MESSAGES.stockists.addEdit.blankName,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.address) {
    if (!formData.address.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.address,
        message: APP_ERROR_MESSAGES.stockists.addEdit.blankAddress,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.zone) {
    if (!formData.zone) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.zone,
        message: APP_ERROR_MESSAGES.stockists.addEdit.blankZone,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.city) {
    if (!formData.city) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.city,
        message: APP_ERROR_MESSAGES.stockists.addEdit.blankCity,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.state) {
    if (!formData.state) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.state,
        message: APP_ERROR_MESSAGES.stockists.addEdit.blankState,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.pincode) {
    if (!formData.pincode.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.pincode,
        message: APP_ERROR_MESSAGES.stockists.addEdit.blankPincode,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.website) {
    if (formData.website && !Regex.website.test(formData.website)) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.website,
        message: APP_ERROR_MESSAGES.stockists.addEdit.invalidWebsite,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.gstNumber) {
    if (!formData.gstNumber.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.gstNumber,
        message: APP_ERROR_MESSAGES.stockists.addEdit.blankGST,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.email) {
    if (!formData.email.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.email,
        message: APP_ERROR_MESSAGES.stockists.addEdit.blankEmail,
      });
    } else if (!Regex.email.test(formData.email.trim())) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.email,
        message: APP_ERROR_MESSAGES.stockists.addEdit.invalidEmail,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.primaryContactPerson) {
    if (!formData.primaryContactPerson.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.primaryContactPerson,
        message: APP_ERROR_MESSAGES.stockists.addEdit.blankPrimaryContactPerson,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.primaryContactNumber) {
    if (!formData.primaryContactNumber.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.primaryContactNumber,
        message: APP_ERROR_MESSAGES.stockists.addEdit.blankPrimaryContactNumber,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.primaryContactEmail) {
    if (!formData.primaryContactEmail.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.primaryContactEmail,
        message: APP_ERROR_MESSAGES.stockists.addEdit.blankPrimaryContactEmail,
      });
    } else if (!Regex.email.test(formData.primaryContactEmail.trim())) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.primaryContactEmail,
        message: APP_ERROR_MESSAGES.stockists.addEdit.invalidPrimaryContactEmail,
      });
    }
  }

  return validations;
};

export const validateBranchForm = (formData: any, fieldToValidate?: string) => {
  const validations: Validation = { validate: true, fields: [] };

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.name) {
    if (!formData.name.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.name,
        message: APP_ERROR_MESSAGES.stockists.addEdit.blankName,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.address) {
    if (!formData.address.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.address,
        message: APP_ERROR_MESSAGES.stockists.addEdit.blankAddress,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.city) {
    if (!formData.city) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.city,
        message: APP_ERROR_MESSAGES.stockists.addEdit.blankCity,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.state) {
    if (!formData.state) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.state,
        message: APP_ERROR_MESSAGES.stockists.addEdit.blankState,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.pincode) {
    if (!formData.pincode.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.pincode,
        message: APP_ERROR_MESSAGES.stockists.addEdit.blankPincode,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.email) {
    if (!formData.email.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.email,
        message: APP_ERROR_MESSAGES.stockists.addEdit.blankEmail,
      });
    } else if (!Regex.email.test(formData.email.trim())) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.email,
        message: APP_ERROR_MESSAGES.stockists.addEdit.invalidEmail,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.primaryContactPerson) {
    if (!formData.primaryContactPerson.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.primaryContactPerson,
        message: APP_ERROR_MESSAGES.stockists.addEdit.blankPrimaryContactPerson,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.primaryContactNumber) {
    if (!formData.primaryContactNumber) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.primaryContactNumber,
        message: APP_ERROR_MESSAGES.stockists.addEdit.blankPrimaryContactNumber,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.primaryContactEmail) {
    if (!formData.primaryContactEmail.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.primaryContactEmail,
        message: APP_ERROR_MESSAGES.stockists.addEdit.blankPrimaryContactEmail,
      });
    } else if (!Regex.email.test(formData.primaryContactEmail.trim())) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.primaryContactEmail,
        message: APP_ERROR_MESSAGES.stockists.addEdit.invalidPrimaryContactEmail,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.template) {
    if (!formData[VALIDATION_FIELD_MAPPING.template]) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.template,
        message: APP_ERROR_MESSAGES.stockists.addEdit.blankTemplate,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.mrUser) {
    if (!formData[VALIDATION_FIELD_MAPPING.mrUser]) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.mrUser,
        message: APP_ERROR_MESSAGES.stockists.addEdit.blankMrUser,
      });
    }
  }

  return validations;
};

export const validateProductForm = (formData: any, fieldToValidate?: string) => {
  const validations: Validation = { validate: true, fields: [] };

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.name) {
    if (!formData.name.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.name,
        message: APP_ERROR_MESSAGES.stockistProducts.addEdit.blankName,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.description) {
    if (!formData.description.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.description,
        message: APP_ERROR_MESSAGES.stockistProducts.addEdit.blankDescription,
      });
    }
  }

  return validations;
};
